<template lang="pug">

	span(:style="{ color: dynamicColor}")
		v-icon(medium :color="dynamicColor" ) {{ dynamicIcon }}
		strong {{ name ? name : '---' }}

</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
		computed: {
            dynamicColor() {
				switch(this.name) {
					case "Processed":
						return "var(--orange)"
					case "Dropped":
						return "var(--pink)"
					case "Delivered":
						return "var(--purple)"
					case "Deferred":
						return "var(--success)"
					case "Bounce":
						return "var(--volie-teal)"
					case "Open":
						return "var(--warning)"
					case "Click":
						return "var(--volie-teal-70)"
					case "Complained":
						return "var(--volie-blue-50)"
					case "Unsubscribe":
						return "var(--volie-blue)"
					case "Group Unsubscribe":
						return "var(--yellow)"
					case "Group Resubscribe":
						return "var(--dark-blue)"
					default:
						return ""
				}
			},
			dynamicIcon() {
				switch(this.name) {
					case "Processed":
						return "mdi-email-sync"
					case "Dropped":
						return "mdi-email-off"
					case "Delivered":
						return "mdi-email-send"
					case "Deferred":
						return "mdi-email-sync"
					case "Bounce":
						return "mdi-email-off"
					case "Open":
						return "mdi-email-open"
					case "Click":
						return "mdi-email-check"
					case "Complained":
						return "mdi-email-alert"
					case "Unsubscribe":
						return "mdi-email-minus"
					case "Group Unsubscribe":
						return "mdi-email-minus"
					case "Group Resubscribe":
						return "mdi-email-plus"
					default:
						return ""
				}
			},
        },
        props: {
            name: String,
        },
    });
</script>

<style lang="scss" scoped>
</style>
